export const percentageString = (number: number): string =>
  `${Math.round(number * 100)}%`
